import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const sliderDefinition: ComponentDefinition = {
  id: 'slider',
  name: 'Slider',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/gallery-horizontal.svg',
  children: true,
  variables: {
    autoplay: {
      type: 'Boolean',
      displayName: 'Auto-scroll',
      defaultValue: true,
      group: 'style',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    controls: {
      type: 'Boolean',
      displayName: 'Controls',
      defaultValue: true,
      group: 'style',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    featuredMove: {
      type: 'Text',
      displayName: 'Movement type',
      defaultValue: 'moveDown',
      group: 'style',
      validations: {
        in: [
          { value: 'moveDown', displayName: 'Move down' },
          { value: 'grow', displayName: 'Grow' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    border: {
      type: 'Boolean',
      displayName: 'Slide border',
      defaultValue: true,
      group: 'style',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    borderRadius: {
      type: 'Boolean',
      displayName: 'Rounded corners',
      defaultValue: true,
      group: 'style',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    slideBackground: {
      type: 'Text',
      displayName: 'Slide background colour',
      defaultValue: '_bg-white',
      group: 'style',
      validations: {
        in: [
          { value: '_bg-white', displayName: 'White' },
          { value: '_bg-light-grey', displayName: 'Light grey' },
          { value: '_bg-light-pink', displayName: 'Light pink' },
          { value: '_bg-dark-pink', displayName: 'Dark pink' },
        ],
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    shadow: {
      type: 'Boolean',
      displayName: 'Slide shadow',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
  },
} as const;
